(() => {
  window.dataLayer = window.dataLayer || [];
  function gtag(){ dataLayer.push(arguments); }
  const denied = { ad_storage:'denied', analytics_storage:'denied', ad_user_data:'denied', ad_personalization:'denied' };
  const granted = { ad_storage:'granted', analytics_storage:'granted', ad_user_data:'granted', ad_personalization:'granted' };
  gtag('consent', 'default', denied);
  const key = 'herlayra_cookie_consent';
  const hasGpc = navigator.globalPrivacyControl === true;
  if(hasGpc && localStorage.getItem(key) !== 'declined') localStorage.setItem(key, 'declined');

  function apply(v){ gtag('consent','update', v === 'accepted' && !hasGpc ? granted : denied); }
  function choiceText(){
    return hasGpc
      ? 'Your browser privacy signal is enabled, so advertising and analytics storage remain off. You can still review our privacy policy.'
      : 'We use analytics and advertising cookies only with your consent. You can change your choice anytime.';
  }
  function showChoices(force){
    if(document.querySelector('[data-hly-consent]')) return;
    if(!force && localStorage.getItem(key)) return;
    const bar = document.createElement('div');
    bar.setAttribute('role','region');
    bar.setAttribute('aria-label','Privacy choices');
    bar.setAttribute('data-hly-consent','');
    bar.style.cssText = 'position:fixed;left:16px;right:16px;bottom:16px;z-index:90;background:#FAFAF7;color:#0C3B48;border:1px solid #D8D2BE;border-radius:8px;padding:14px;box-shadow:0 10px 28px rgba(12,59,72,.16);font:14px Inter,system-ui,sans-serif';
    bar.innerHTML = '<b>Privacy choices</b><div style="margin:6px 0 10px">' + choiceText() + ' <a href="/policies/privacy-policy" style="color:#0C3B48;text-decoration:underline;text-underline-offset:3px">Privacy Policy</a>.</div><button data-accept style="background:#0C3B48;color:#F5F2E6;border:0;border-radius:8px;padding:10px 14px;margin-right:8px;min-height:44px;display:inline-flex;align-items:center">Accept</button><button data-decline style="background:#fff;color:#0C3B48;border:1px solid #0C3B48;border-radius:8px;padding:10px 14px;min-height:44px;display:inline-flex;align-items:center">Decline</button>';
    if(hasGpc) bar.querySelector('[data-accept]')?.setAttribute('hidden','');
    document.body.appendChild(bar);
    bar.querySelector('[data-accept]')?.addEventListener('click', () => { localStorage.setItem(key,'accepted'); apply('accepted'); bar.remove(); });
    bar.querySelector('[data-decline]')?.addEventListener('click', () => { localStorage.setItem(key,'declined'); apply('declined'); bar.remove(); });
  }

  apply(localStorage.getItem(key));
  document.addEventListener('DOMContentLoaded', () => {
    showChoices(false);
    document.querySelectorAll('[data-privacy-choices]').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        showChoices(true);
      });
    });
  });
})();
